import './countryCard.scss';
import { BlackCheck } from '../';
import { Input, InputNumber, Select } from 'antd';
import { TAny } from '../../../../types/blog';
import { FC, useEffect, useState } from 'react';
import { ICountryDetail, IUpdateCountry } from '../../../../types/countries';
import { LoaderCard } from '../index';
import { SearchIcon } from '../../../../assets/images/countryList';

interface IProvidersList {
  value: string;
  label: string;
}
interface ICountryCard {
  countryData?: ICountryDetail;
  handleupdateCountry?: (data: IUpdateCountry, countryId: number) => void;
  handleNewProvider?: (provider: string, countryCode: string, countryId: number) => void;
  handleAddNewCountry?: (data: IUpdateCountry) => void;
  updateLoading?: number;
  addLoading?: boolean;
}

const CountryCard: FC<ICountryCard> = ({
  countryData,
  handleupdateCountry,
  handleNewProvider,
  handleAddNewCountry,
  updateLoading,
  addLoading
}: ICountryCard) => {
  const [searchString, setSearchString] = useState<string>('');
  const [updateCountry, setUpdateCountry] = useState<IUpdateCountry>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [defaultSearch, setDefaulSearch] = useState<IProvidersList[]>([]);
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const onChange = (value: string) => {};
  const loadingCard = !!countryData?.id ? updateLoading === countryData?.id : false || addLoading;
  const onSearch = (value: string) => {
    setSearchString(value);
  };

  const addItem = () => {
    if (handleNewProvider && countryData?.id && countryData?.code) {
      handleNewProvider(searchString, countryData?.code, countryData?.id);
    }
  };

  const generateProvidersList = () => {
    if (countryData?.providers) {
      const formatProviders: IProvidersList[] = [];
      for (const provider of countryData?.providers) {
        const newProvider: IProvidersList = {
          label: provider,
          value: provider
        };
        formatProviders.push(newProvider);
      }
      setDefaulSearch([...formatProviders]);
    }
  };

  const defaultData = () => {
    if (countryData) {
      setUpdateCountry({
        exchangeRate: countryData?.exchangeRate,
        taxRate: countryData.taxRate,
        phoneCode: countryData?.phoneCode,
        documentExample: countryData?.documentExample,
        registry: !!countryData?.registry,
        buy: !!countryData?.buy,
        logisticService: !!countryData?.logisticService,
        storage: !!countryData?.storage
      });
      if (countryData.providers && countryData.providers.length > 0) {
        generateProvidersList();
      }
    }
  };

  const saveData = () => {
    if (countryData?.id && handleupdateCountry) {
      const updateBody = {
        currencyId: countryData.currencyId,
        exchangeRate: updateCountry?.exchangeRate,
        taxRate: updateCountry?.taxRate,
        phoneCode: updateCountry?.phoneCode,
        documentTypeId: countryData.documentTypeId,
        documentExample: updateCountry?.documentExample,
        registry: updateCountry?.registry,
        buy: updateCountry?.buy,
        logisticService: updateCountry?.logisticService,
        storage: updateCountry?.storage
      };
      handleupdateCountry(updateBody, countryData.id);
      setIsEdit(false);
    }
    if (!countryData?.id && handleAddNewCountry) {
      const createBody = {
        exchangeRate: updateCountry?.exchangeRate,
        taxRate: updateCountry?.taxRate,
        phoneCode: updateCountry?.phoneCode,
        documentExample: updateCountry?.documentExample,
        registry: updateCountry?.registry,
        buy: updateCountry?.buy,
        logisticService: updateCountry?.logisticService,
        storage: updateCountry?.storage
      };
      handleAddNewCountry(createBody);
    }
  };

  const noValidForm = () => {
    if (!updateCountry) return true;
    const { exchangeRate, taxRate, phoneCode, documentExample } = updateCountry || {};
    const taxRateIsNotValid = !['number', 'string'].includes(typeof taxRate);
    if (!exchangeRate || taxRateIsNotValid || !phoneCode || !documentExample) return true;
    return false;
  };

  const disabledButton = () => {
    if (!!countryData) {
      if (countryData?.id) {
        if (!isEdit || noValidForm()) {
          return true;
        }
        return false;
      } else {
        return noValidForm();
      }
    } else return true;
  };

  const validateDocument = (example: string) => {
    if (example && example.length > 0) {
      const formatExample = example.toLocaleUpperCase();
      const letterList = formatExample.split('');
      const myLetterList = letterList;
      let finalList: string[] = [];
      for (let letter of myLetterList) {
        if (letter === 'X' || letter === '0' || letter === 'Y' || letter === '.' || letter === '-' || letter === '/') {
          finalList.push(letter);
        }
      }
      const finalWord = finalList.join('');
      setUpdateCountry({ ...updateCountry, ...{ documentExample: finalWord } });
    } else {
      setUpdateCountry({ ...updateCountry, ...{ documentExample: '' } });
    }
  };

  useEffect(() => {
    defaultData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryData]);
  return (
    <>
      {updateCountry && !loadingCard ? (
        <div id="countryCard">
          <div className="boxCountryCard">
            <div className="flagContainer">
              <div className="flagBox" style={{ backgroundImage: `url(${countryData?.flag})` }} />
              <div className="countryNameHover">{countryData?.name || 'Sin información del nombre'}</div>
            </div>
            <div className="rateContainer">
              <div className="containerRateInput">
                <div className="labelCountryInput" style={{ color: updateCountry?.exchangeRate ? '#383838' : '' }}>
                  {countryData?.currencyCode}
                </div>
                <div className="inputCountry">
                  <InputNumber
                    onChange={e => {
                      setIsEdit(true);
                      setUpdateCountry({ ...updateCountry, ...{ exchangeRate: e } });
                    }}
                    placeholder={countryData?.currencyCode}
                    defaultValue={updateCountry?.exchangeRate}
                    style={{ border: updateCountry?.exchangeRate ? '1px solid #999999' : '' }}
                    className="countryNumberInput"
                  />
                </div>
              </div>
            </div>
            <div className="taxesContainer">
              <div className="containerTaxesInput">
                <div className="labelCountryInput" style={{ color: updateCountry?.taxRate ? '#383838' : '' }}>
                  Impuestos
                </div>
                <div className="inputCountry">
                  <InputNumber
                    defaultValue={updateCountry?.taxRate}
                    onChange={e => {
                      setIsEdit(true);
                      setUpdateCountry({ ...updateCountry, ...{ taxRate: e } });
                    }}
                    formatter={value => `${value}%`}
                    parser={value => value!.replace('%', '')}
                    style={{ border: updateCountry?.taxRate ? '1px solid #999999' : '' }}
                    className="countryNumberInput"
                  />
                </div>
              </div>
            </div>
            <div className="indicativeContainer">
              <div className="containerIndicativeInput">
                <div className="labelCountryInput" style={{ color: updateCountry?.phoneCode ? '#383838' : '' }}>
                  Indicativo
                </div>
                <div className="inputCountry">
                  <InputNumber
                    defaultValue={updateCountry?.phoneCode}
                    onChange={e => {
                      setIsEdit(true);
                      setUpdateCountry({ ...updateCountry, ...{ phoneCode: e } });
                    }}
                    formatter={value => `+ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={value => value!.replace(/\+\s?|(,*)/g, '')}
                    style={{ border: updateCountry?.phoneCode ? '1px solid #999999' : '' }}
                    className="countryNumberInput"
                  />
                </div>
              </div>
            </div>
            <div className="documentContainer">
              <div className="containerDocumentInput">
                <div
                  className="labelCountryInput uppercase"
                  style={{ color: updateCountry?.documentExample ? '#383838' : '' }}
                >
                  {countryData?.documentType}
                </div>
                <div className="inputCountry">
                  <div className="inputCountry">
                    <Input
                      defaultValue={updateCountry?.documentExample}
                      onChange={e => {
                        setIsEdit(true);
                        validateDocument(e.target.value);
                      }}
                      placeholder={countryData?.documentType || ''}
                      style={{ border: updateCountry?.documentExample ? '1px solid #999999' : '' }}
                      className="countrySimpleInput"
                      value={updateCountry?.documentExample}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="providerContainer">
              <div className="containerProviderInput">
                <div
                  className="labelCountryInput"
                  style={{ color: countryData?.providers && countryData?.providers.length > 0 ? '#383838' : '' }}
                >
                  Proveedor
                </div>
                <div
                  className="selectProviders customBoder"
                  style={{
                    border: countryData?.providers && countryData?.providers.length > 0 ? '1px solid #999999' : ''
                  }}
                >
                  {!countryData?.id && (
                    <div
                      className="floatInput"
                      onMouseEnter={() => {
                        setOpenAlert(true);
                      }}
                      onMouseLeave={() => {
                        setOpenAlert(false);
                      }}
                    >
                      {openAlert && (
                        <div className="floatAlert">
                          Primero debes terminar de crear el país para luego elegir los proveedores{' '}
                        </div>
                      )}
                    </div>
                  )}
                  <div className="floatIcon">
                    <SearchIcon
                      stroke={countryData?.providers && countryData?.providers.length > 0 ? '#383838' : '#CCCCCC'}
                      fill={!countryData?.id ? '#FAFAFA' : '#FFFFFF'}
                    />
                  </div>

                  <Select
                    defaultValue={
                      countryData?.providers && countryData?.providers?.length > 0
                        ? countryData.providers.toString().replaceAll(',', ', ')
                        : undefined
                    }
                    className="customSelect w-full"
                    showArrow={false}
                    showSearch
                    disabled={!countryData?.id}
                    placeholder="Buscar"
                    optionFilterProp={'children'}
                    onChange={onChange}
                    onSearch={onSearch}
                    notFoundContent={
                      searchString ? (
                        <div className="newProvider">
                          {`${searchString.length > 10 ? `${searchString.substring(0, 10)}...` : `${searchString}`} - `}
                          <span
                            className="text-red-500 leading-8 text-xs cursor-pointer"
                            style={{ color: '#DD524C' }}
                            onClick={() => {
                              addItem();
                            }}
                          >
                            Nuevo
                          </span>
                        </div>
                      ) : (
                        false
                      )
                    }
                    filterOption={(input, option: TAny) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={defaultSearch}
                  />
                </div>
              </div>
            </div>
            <div className="registerContainer">
              <BlackCheck
                handleChangeCheck={() => {
                  setIsEdit(true);
                  setUpdateCountry({ ...updateCountry, ...{ registry: !updateCountry?.registry } });
                }}
                checked={!!updateCountry?.registry}
              />
            </div>
            <div className="extraSpace" />
            <div className="buyContainer">
              <BlackCheck
                handleChangeCheck={() => {
                  setIsEdit(true);
                  setUpdateCountry({ ...updateCountry, ...{ buy: !updateCountry?.buy } });
                }}
                checked={!!updateCountry?.buy}
              />
            </div>
            <div className="extraSpace" />
            <div className="servicesContainer">
              <BlackCheck
                handleChangeCheck={() => {
                  setIsEdit(true);
                  setUpdateCountry({ ...updateCountry, ...{ logisticService: !updateCountry?.logisticService } });
                }}
                checked={!!updateCountry?.logisticService}
              />
            </div>
            <div className="extraSpace" />
            <div className="storeContainer">
              <BlackCheck
                handleChangeCheck={() => {
                  setIsEdit(true);
                  setUpdateCountry({ ...updateCountry, ...{ storage: !updateCountry?.storage } });
                }}
                checked={!!updateCountry?.storage}
              />
            </div>
            <div className="saveContainer">
              <button
                className="saveButton"
                onClick={() => {
                  saveData();
                }}
                disabled={disabledButton() || updateLoading === countryData?.flag}
              >
                {updateLoading === countryData?.flag ? 'Loading' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <LoaderCard />
      )}
    </>
  );
};

export default CountryCard;
